import React from "react";
import { useUserServices } from "../../context/DealerProfile";
import { User, Mail, Phone, CheckCircle } from "lucide-react";

const Profile = () => {
  const {
    dealerDetail: { crmUserDetail, dealerName, accountName },
  } = useUserServices();

  return (
    <div className="bg-white overflow-hidden shadow rounded-lg border max-w-[700px] mx-auto mt-7">
      <div className="px-4 py-5 sm:px-6 text-center">
        <h3 className="text-2xl text-center leading-7 font-semibold text-gray-900 items-center gap-2">
          Your Profile Detail
        </h3>
        <p className="mt-2 max-w-2xl text-base text-gray-600">
          This is some information about You.
        </p>
      </div>
      <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
          <div className="py-4 sm:py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-base font-semibold text-gray-600 flex items-center gap-2">
              <User className="w-5 h-5 text-gray-600" /> Full name
            </dt>
            <dd className="mt-1 text-lg text-gray-800 sm:mt-0 sm:col-span-2">
              {dealerName?.name ?? accountName?.name}
            </dd>
          </div>
          <div className="py-4 sm:py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-base font-semibold text-gray-600 flex items-center gap-2">
              <Mail className="w-5 h-5 text-gray-600" /> Email address
            </dt>
            <dd className="mt-1 text-lg text-gray-800 sm:mt-0 sm:col-span-2">
              {crmUserDetail?.Email ?? "N/A"}
            </dd>
          </div>
          <div className="py-4 sm:py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-base font-semibold text-gray-600 flex items-center gap-2">
              <Phone className="w-5 h-5 text-gray-600" /> Phone number
            </dt>
            <dd className="mt-1 text-lg text-gray-800 sm:mt-0 sm:col-span-2">
              {crmUserDetail?.Phone ?? "N/A"}
            </dd>
          </div>
          <div className="py-4 sm:py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-base font-semibold text-gray-600 flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-gray-600" /> Status
            </dt>
            <dd className="mt-1 text-lg text-gray-800 sm:mt-0 sm:col-span-2">
              Active
            </dd>
          </div>
        </dl>
      </div>
    </div>
  );
};

export default Profile;
